/* Nexus category + status metadata + brand helpers */
export const CATEGORIES = [
  { id: "regulated_financial_licence", label: "Regulated Financial Licence" },
  { id: "business_stake", label: "Business Stake" },
  { id: "technology_ip", label: "Technology / IP" },
  { id: "fund_structure", label: "Fund Structure" },
  { id: "igaming_platform", label: "iGaming / Platform" },
  { id: "commercial_real_estate", label: "Commercial Real Estate" },
];

export const REGION_GROUPS = [
  { id: "eu_regulated", label: "EU Regulated" },
  { id: "midshore_offshore", label: "Mid-Shore & Offshore" },
  { id: "north_america", label: "North America" },
  { id: "global", label: "Global" },
];

export const STATUS_META = {
  new:            { label: "New",            dot: "#C9896E", cls: "st-new" },
  // "verified" badges are held back until register-verification is confirmed;
  // any legacy record with status_badge="verified" is rendered as "Available".
  verified:       { label: "Available",      dot: "#7FB08A", cls: "st-available" },
  available:      { label: "Available",      dot: "#7FB08A", cls: "st-available" },
  under_offer:    { label: "Under Offer",    dot: "#0D1323", cls: "st-underoffer" },
  reserved:       { label: "Reserved",       dot: "#8a8580", cls: "st-reserved" },
  recently_sold:  { label: "Recently Sold",  dot: "#5a544c", cls: "st-sold" },
};

export const categoryLabel = (id) => CATEGORIES.find(c => c.id === id)?.label || id;
export const regionLabel = (id) => REGION_GROUPS.find(r => r.id === id)?.label || id;

export const localizeListing = (listing, lang) => {
  const tr = listing?.translations?.[(lang || "en").split("-")[0]];
  if (!tr) return listing;
  return {
    ...listing,
    title: tr.title || listing.title,
    teaser_summary: tr.teaser_summary || listing.teaser_summary,
    highlights: tr.highlights?.length ? tr.highlights : listing.highlights,
  };
};
